import { selectJsonQuery } from './selectJsonQuery';
import { IAppState } from '../../common/state';
import { getRailwayAndHighwayPuids } from '../../utils/adfox/getRailwayAndHighwayPuids';

export const selectResultPuids = (state: IAppState): Record<string, string | null | undefined> => {
  const jsonQuery = selectJsonQuery(state);

  const puids: Record<string, string | null | undefined> = {
    ...getRailwayAndHighwayPuids(jsonQuery),
    ...state.results.puids,
  };

  if (state.isQaMode) {
    puids.puid32 = 'test';
  }

  return puids;
};
